<template>
    <div
        id="equipment-list"
        class="col-sm-12"
    >
        <div
            class="data-list-item add"
            @click.stop="$emit('add')"
        >
            <div class="item-img-cont add-title">
                <i class="fa fa-plus" />
            </div>
            <div class="item-text-cont">
                <span class="item-title-add">{{ $t('common.add_new') }}</span>
                <font-awesome-icon
                    icon="barcode"
                    class="card-body-icon"
                />
            </div>
        </div>

        <Transition name="fade">
            <div v-if="results.length > 0" class="col-sm-12 list-content result-table nopads">
                <vue3-datatable
                    ref="resultTable"
                    :rows="results"
                    :columns="fields"
                    :pagination="false"
                    :sticky-header="true"
                    :height="results.length > 8 ? '62vh' : '100%'"
                    :sortable="true"
                    sortColumn=""
                    skin="bh-table-compact"
                    row-class="routa-table-row"
                    cell-class="routa-table-cell"
                    @row-click="emitEdit"
                >
                    <template #type="row">
                        {{ getEquipmentType(row.value.type)}}
                    </template>
                </vue3-datatable>
            </div>
        </transition>
    </div>
</template>


<script>
import {restApi} from '../../mixins/RestApiMixin'
import {areaHelper} from '../../mixins/AreaMixin'
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'EquipmentList',
    mixins: [restApi, areaHelper],
    components: {Vue3Datatable},
    props: {
        results: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data: function () {
        return {
            loading: false,
        }
    },
    computed: {
        fields() {
            return [
                {field: 'id', title: this.$t('materialstorage.list.id'), sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'area.name', title: this.$t('common.area'), sort: true, headerClass: 'routa-table-header'},
                {field: 'name', title: this.$t('equipment.name'), sort: true, headerClass: 'routa-table-header'},
                {field: 'type', title: this.$t('equipment.type'), sort: true, headerClass: 'routa-table-header'}
            ]
        }
    },

    methods: {
        emitEdit(areaEquipment) {
            this.$emit('edit', areaEquipment)
        }
    }
}
</script>

<style scoped>
.map-container {
    height: 250px;
    margin-bottom: -0.2em;
}

.collapse {
    cursor: default;
}
</style>
